import React, { useState } from 'react'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../utils'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { Empty } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { ItensTesteBandeja } from '../../../../../services/relatorioTesteBandeja/GET'
import dayjs from 'dayjs'


interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_teste_bandeja: ItensTesteBandeja[]
  abrirGaveta: Function
  buscar_tabela: string
  setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
}

export const TabelaTesteBandeja: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  listar_teste_bandeja,
  abrirGaveta,
  buscar_tabela,
  setBuscar_tabela
}) => {

  function buscarPatrimonios(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
  
      const nomeSemAcentos = removerAcentos(String(item?.nome_propriedade))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <div style={{ height: 'calc(100vh - 180px)', display:'flex', flexDirection: 'column', gap: '10px' }}>
      <Inline alignItems='center'>
        <Input placeholder='Buscar relatório por propriedade' value={buscar_tabela} onChange={setBuscar_tabela} />
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Data', width: '100px' },
          { valor: 'Propriedade', width: 'calc(100% - 615px)' },
          { valor: 'Equipamento', width: '200px' },
          { valor: 'Farelado/Granulado', width: '200px' },
          { valor: 'Ações', width: '110px' },
        ]}
      />
      
      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: (listar_teste_bandeja ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_teste_bandeja ?? [])
            ?.filter(buscarPatrimonios(buscar_tabela))
            ?.map(({ cod, data, tipo, nome_propriedade, nome_equipamento, nome_usuario }) => {
             
              return (
                <RowTable key={cod} onDoubleClick={() => abrirGaveta(cod, nome_propriedade, nome_equipamento, nome_usuario, data)}>
                  <RowItem fontSize={13} width={'100px'}>
                    {dayjs(data).format('DD/MM/YYYY')}
                  </RowItem>

                  <RowItem fontSize={13} width={'calc(100% - 610px)'}>
                     {nome_propriedade}
                  </RowItem>

                  <RowItem fontSize={13} width={'200px'}>
                    {nome_equipamento}
                  </RowItem>

                  <RowItem fontSize={13} width={'200px'}>
                  {tipo === 'F' ? 'Farelado' : 'Granulado'}
                  </RowItem>

                  <RowItem width={'215px'} gap={10}>
                   
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEye} />}
                      onClick={() => abrirGaveta(cod, nome_propriedade, nome_equipamento, nome_usuario, data)}
                   
                    >
                      Ver
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={listar_teste_bandeja?.length === 0 && !loading}>
          {buscar_tabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscar_tabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando relatórios...'
            justifyContent='center'
            height={'100%'}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
